export class WebhookV1StandardPayloadBackupVaultArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaultArguments",
            "baseName": "vaultArguments",
            "type": "WebhookV1VaultArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadBackupVaultArguments.attributeTypeMap;
    }
    constructor() {
    }
}
